module.exports = __webpack_public_path__ + "img/right_white_arr.9363a998.svg";